import * as React from "react";
import styles from "../SignUpForm.module.scss";
import { PasswordValidators } from "../../../assets/Types/AcfGroupTypes";

const PasswordValidationLabel: React.FC<{
  validation: PasswordValidators;
  beenTouched: boolean;
}> = ({
  validation: {
    containsLowerCase,
    containsNumber,
    containsUpperCase,
    minLength,
  },
  beenTouched,
}) => {
  const lowerCaseError = !containsLowerCase && beenTouched;
  const numberError = !containsNumber && beenTouched;
  const upperCaseError = !containsUpperCase && beenTouched;
  const minLengthError = !minLength && beenTouched;

  return (
    <div className={styles.pwConfirmation}>
      <div className={styles.pwRcontainer}>
        <p
          className={`${lowerCaseError ? styles.activeErrorPW : undefined} ${
            containsLowerCase ? styles.pwValidationSuccess : undefined
          }`}
        >
          One lowercase letter
        </p>
        <p
          className={`${numberError ? styles.activeErrorPW : undefined} ${
            containsNumber ? styles.pwValidationSuccess : undefined
          }`}
        >
          One number
        </p>
      </div>
      <div>
        <p
          className={`${upperCaseError ? styles.activeErrorPW : undefined} ${
            containsUpperCase ? styles.pwValidationSuccess : undefined
          }`}
        >
          One uppercase letter
        </p>
        <p
          className={`${minLengthError ? styles.activeErrorPW : undefined} ${
            minLength ? styles.pwValidationSuccess : undefined
          }`}
        >
          8 characters min
        </p>
      </div>
    </div>
  );
};

export default PasswordValidationLabel;
